// extracted by mini-css-extract-plugin
export default {"modal-validation":"ModalValidation_modal-validation__01gbk"};